// StimulusPage/AdminStimulusPage.js

import React from "react";
import {
  Paper,
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardActionArea,
} from "@mui/material";

const CardBtn = ({ onClick, children }) => (
  <Card sx={{ width: "100%", backgroundColor: "#393939" }}>
    <CardActionArea onClick={onClick}>
      <CardContent>
        <Typography
          sx={{
            fontSize: 20,
            fontFamily: "GmarketSansMedium",
            textAlign: "center",
          }}
          color="white"
        >
          {children}
        </Typography>
      </CardContent>
    </CardActionArea>
  </Card>
);

export default function AdminStimulusPage({
  stim,
  remainingTimeSec,
  recipesLoading,
  recipesError,
  savedRecipes,
  runSavedRecipe,
  goStimulusManager,
  goUserManage,
  formatTime,
  onReconnect, // 🔹 ExperimentMachineListPageMiddle2에서 내려주는 재연결 함수
}) {
  return (
    <Paper
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#131313",
      }}
    >
      {/* 기존 메인 내용 */}
      <Box style={{ color: "#CCCCCC" }}>
        <Box
          style={{
            padding: "0px 10px 30px 10px",
            borderRadius: 5,
            width: "90%",
            marginRight: "5%",
            marginLeft: "5%",
          }}
        >

          {/* 상단 상태 텍스트 */}
          <Box sx={{ marginTop: 5, marginBottom: 3 }}>
            <Typography
              sx={{
                fontSize: 25,
                fontFamily: "GmarketSansMedium",
              }}
              color="white"
            >
              자극 상태 : ({stim})
            </Typography>
            <Typography
              sx={{
                fontSize: 25,
                fontFamily: "GmarketSansMedium",
              }}
              color="white"
            >
              남은 지속 시간: ({formatTime(remainingTimeSec)})
            </Typography>
          </Box>

          {/* 오른쪽 저장된 자극 레시피 영역 */}
          <Typography
            sx={{
              fontSize: 22,
              fontFamily: "GmarketSansMedium",
              marginBottom: 1,
            }}
            color="white"
          >
            저장된 자극 레시피
          </Typography>

          {recipesLoading && (
            <Typography
              sx={{ fontSize: 16, fontFamily: "GmarketSansMedium" }}
              color="gray"
            >
              레시피 불러오는 중.
            </Typography>
          )}

          {recipesError && (
            <Typography
              sx={{ fontSize: 16, fontFamily: "GmarketSansMedium" }}
              color="red"
            >
              {recipesError}
            </Typography>
          )}

          {!recipesLoading && !recipesError && savedRecipes.length === 0 && (
            <Typography
              sx={{ fontSize: 16, fontFamily: "GmarketSansMedium" }}
              color="gray"
            >
              저장된 자극 레시피가 없습니다.
            </Typography>
          )}

          <Grid container spacing={2} sx={{ marginTop: 1 }}>
            {savedRecipes.map((r) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={r.id}>
                <CardBtn onClick={runSavedRecipe(r)}>
                  {r.name || `자극 #${r.id}`}
                </CardBtn>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Paper>
  );
}
